import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Header, Segment, Divider, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import VisibilitySensor from 'react-visibility-sensor';
import {FemaGoTable} from 'app-ui-componentlibrary';

const DEFAULT_WEIGHT = 0.5;

export const gridRowData = (label, value) => (
  <Grid.Row key={label + value}>
    <Grid.Column width="6">{label}</Grid.Column>
    <Grid.Column width="10">
      <strong>{value}</strong>
    </Grid.Column>
  </Grid.Row>
);

export const gridRowHeader = (header) => (
  <Grid.Row key={header}>
    <Grid.Column width="16">
      <Divider />
      <Header as="h4">{header}</Header>
    </Grid.Column>
  </Grid.Row>
);

export const buildContent = (tableDiscussionComments, panelChairComments) => {
  const content = [];
  content.push(gridRowHeader('Table discussion comments'));
  content.push(gridRowData('Reviewer', 'Comment'));
  _.forEach(tableDiscussionComments, (comment) => {
    content.push(gridRowData(comment.author, comment.comment));
  });
  content.push(gridRowHeader('Panel chair comments'));
  content.push(gridRowData('Reviewer', 'Comment'));
  _.forEach(panelChairComments, (comment) => {
    content.push(gridRowData(comment.author, comment.comment));
  });
  return content;
};

export const calculateOverallActivityScore = (
  preScore,
  panelScore,
  prescoreWeightConfig
) => {
  const preScoreWeight = prescoreWeightConfig || DEFAULT_WEIGHT;
  const panelScoreWeight = 1 - preScoreWeight;

  return (preScore * preScoreWeight + panelScore * panelScoreWeight).toFixed(2);
};

export const buildTable = (scores, weights) => {
  let rows = _.map(scores.panelScores, (panel, index) => {
    let preScore = _.find(
      scores.preScores,
      (pre) => panel.activityName === pre.activityName
    );

    const preScoreWeight = _.get(weights, panel.activityName);

    let panelScoreValue =
      panel.score && _.isNumber(panel.score) ? panel.score.toFixed(2) : 'n/a';
    let preScoreValue =
      preScore && _.isNumber(preScore.score) ? preScore.score.toFixed(2) : 'n/a';
    let average;
    if (panel && _.isNumber(panel.score) && preScore && _.isNumber(preScore.score))
      average = calculateOverallActivityScore(
        preScore.score,
        panel.score,
        preScoreWeight
      );
    else if (panel.score) average = panel.score;
    else if (preScore.score) average = preScore.score;
    else average = 'n/a';
    return (
      <FemaGoTable.Row key={index}>
        <FemaGoTable.TextCell>{panel.activityName}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>{panelScoreValue}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>{preScoreValue}</FemaGoTable.TextCell>
        <FemaGoTable.TextCell>{average}</FemaGoTable.TextCell>
      </FemaGoTable.Row>
    );
  });
  return (
    <React.Fragment>
      <FemaGoTable type="static" summary="Score summary">
        <FemaGoTable.Header>
          <FemaGoTable.Row>
            <FemaGoTable.HeaderCell>Activity</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Panel score average</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Pre-score</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Overall score</FemaGoTable.HeaderCell>
          </FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>{rows}</FemaGoTable.Body>
      </FemaGoTable>
    </React.Fragment>
  );
};

export class PanelScoreSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableDiscussionComments: [],
      panelChairComments: [],
      error: false,
    };
  }

  UNSAFE_componentWillMount() {
    const {grantId, token} = this.props;
    if (grantId) {
      this.props.getPanelComments(token, grantId).then((res) => {
        if (res && res.type === 'API_COMMENT_GET_SUCCESS') {
          _.forEach(res.payload, (comment) => {
            if (comment.task === 'table-discussion')
              this.setState({
                tableDiscussionComments: [...this.state.tableDiscussionComments, comment],
              });
            if (comment.task === 'chair-review')
              this.setState({
                panelChairComments: [...this.state.panelChairComments, comment],
              });
          });
        }
      });
    }
  }

  onVisibilityChange = (isVisible) => {
    if (this.props.handleVisibilityChange)
      this.props.handleVisibilityChange(this.props.spot, isVisible);
  };

  render() {
    const {tableDiscussionComments, panelChairComments} = this.state;
    const {prescoreWeight} = this.props.config || {};

    const content = (
      <React.Fragment>
        <Header id={this.props.title} name={this.props.title} as="h2">
          {this.props.title}
        </Header>
        {buildTable(this.props.scores, prescoreWeight)}
        <Grid>{buildContent(tableDiscussionComments, panelChairComments)}</Grid>
      </React.Fragment>
    );
    if (this.props.samePageNav) {
      return (
        <VisibilitySensor
          onChange={this.onVisibilityChange}
          partialVisibility={true}
          delayedCall={true}
          offset={{top: 150, bottom: 150}}
        >
          {content}
        </VisibilitySensor>
      );
    } else return content;
  }
}

export const mapStateToProps = (state) => {
  const props = {};
  props.scores = _.get(state, 'dynamicComponent.context.scores');
  props.grantId = _.get(
    state,
    'dynamicComponent.context.workflowTask.processVariables.grantId'
  );
  props.token = _.get(state, 'auth.token');
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  getPanelComments: (token, grantId) =>
    dispatch(ApiActions.comments.getCommentsForGrant(token, grantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelScoreSummary);
